import React, { useRef, useState, } from "react";
import TopMenuLabel from "./components/TopMenuLabel";
import RenderTopMenu from "./RenderTopMenu";
import { closeMenu, toggleMenu, useTopMenuState } from "./slice";
import { useDispatch } from "react-redux";
import StyledMenu from "./components/StyledMenu";
import { nestedMenuWidth } from "./utils/configuration";
import { useAutofocusAfterClose } from "./hooks/useAutofocusAfterClose";
const countHowMuchFitToLeft = (target) => {
    const rectangle = target.getBoundingClientRect();
    const spaceFromRight = window.innerWidth - rectangle.right - nestedMenuWidth;
    return Math.ceil(spaceFromRight / nestedMenuWidth);
};
const TopMenuLevelZero = ({ menu }) => {
    const ref = useRef(null);
    const dispatch = useDispatch();
    const [breakLevel, setBreakLevel] = useState(Infinity);
    const { openKeys } = useTopMenuState();
    const key = "0-" + menu.ID;
    const open = openKeys.includes(key);
    const toggle = () => dispatch(toggleMenu(key));
    const handleClick = (event) => {
        const target = event.target;
        const levelToBreak = countHowMuchFitToLeft(target);
        setBreakLevel(levelToBreak);
        toggle();
    };
    const handleClose = () => dispatch(closeMenu(""));
    const handleMouseEnter = (event) => {
        if (openKeys.length > 0 && !open) {
            handleClick(event);
        }
    };
    useAutofocusAfterClose(open, openKeys, ref);
    const handleKeyDown = (event) => {
        const target = event.target;
        const menuItem = menu.Items.find((x) => x.ID === target.id);
        const cancelDefault = () => {
            event.stopPropagation();
            event.preventDefault();
        };
        switch (event.code) {
            case "Tab":
                toggle();
                cancelDefault();
                break;
            case "ArrowRight":
                if (menuItem?.HasChilds) {
                    target.click();
                    cancelDefault();
                }
                break;
        }
    };
    return (<>
      <TopMenuLabel id={menu.ID} title={menu.Title} icon={menu.Icon} selected={open} onClick={handleClick} onMouseEnter={handleMouseEnter} containerRef={ref}/>
      <StyledMenu open={open} anchorEl={ref?.current} anchorOrigin={{ horizontal: "left", vertical: "bottom" }} transformOrigin={{ vertical: "top", horizontal: "left" }} MenuListProps={{ onKeyDown: handleKeyDown }} onClose={handleClose} enableBackdrop disableRestoreFocus>
        {menu.Items.map((subItem, index) => (<RenderTopMenu key={subItem.ID} menuItem={subItem} level={1} breakLevel={breakLevel} last={index + 1 === menu.Items.length} siblings={menu.Items}/>))}
      </StyledMenu>
    </>);
};
export default TopMenuLevelZero;
